import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getBoldedText from "@insite/client-framework/Common/Utilities/getPatternBolded";
import { GetWishListsApiParameter } from "@insite/client-framework/Services/WishListService";
import translate from "@insite/client-framework/Translate";
import SearchFieldWrapper, {
    SearchFieldWrapperStyles,
} from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import DynamicDropdown, { DynamicDropdownPresentationProps, OptionObject } from "@insite/mobius/DynamicDropdown";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import debounce from "lodash/debounce";
import React, { ChangeEvent, useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    getWishListsParameter: GetWishListsApiParameter;
    getAutocompleteModel: Function;
    updateLoadParameter: Function;
}

export interface MyListsSearchFieldBrandStyles {
    wrapper?: SearchFieldWrapperStyles;
    searchDynamicDropdown?: DynamicDropdownPresentationProps;
    optionWrapper?: InjectableCss;
    infoWrapper?: InjectableCss;
    autocompleteTitleText?: TypographyPresentationProps;
    autocompleteValueText?: TypographyPresentationProps;
}

export const searchFieldBrandStyles: MyListsSearchFieldBrandStyles = {
    optionWrapper: {
        css: css`
            display: flex;
            cursor: pointer;
        `,
    },
    infoWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    autocompleteTitleText: {
        size: 14,
    },
    autocompleteValueText: {
        size: 14,
        css: css`
            margin-top: 5px;
        `,
    },
};
const styles = searchFieldBrandStyles;

type Props = OwnProps;

const MyListsSearchFieldBrand: React.FC<Props> = ({
    getWishListsParameter,
    getAutocompleteModel,
    updateLoadParameter,
}: Props) => {
    const [options, setOptions] = useState<OptionObject[]>([]);

    const onSelectionChangeHandler = (brandId?: string) => {
        updateLoadParameter({ brandId });
    };

    const debouncedSearchProducts = debounce((query: string) => {
        getAutocompleteModel({
            query,
            searchOnTyping: true,
            onSuccess: (result: any) => {
                if (!result?.brands) {
                    return;
                }

                const newOptions = result.brands.map((brand: any) => {
                    return {
                        optionText: brand.title,
                        optionValue: brand.id || undefined,
                        rowChildren: (
                            <StyledWrapper {...styles.optionWrapper}>
                                <StyledWrapper {...styles.infoWrapper}>
                                    <Typography {...styles.autocompleteTitleText}>{brand.displayTitle}</Typography>
                                </StyledWrapper>
                            </StyledWrapper>
                        ),
                    };
                });
                setOptions(newOptions);
            },
            onComplete(resultProps: any) {
                if (resultProps?.apiResult) {
                    // eslint-disable-next-line react/no-this-in-sfc
                    this.onSuccess?.(resultProps?.apiResult);
                }
            },
        });
    }, 300);

    const onInputChanged = (event: ChangeEvent<HTMLInputElement>) => {
        debouncedSearchProducts(event.target.value);
    };

    return (
        <SearchFieldWrapper extendedStyles={styles.wrapper}>
            <DynamicDropdown
                {...styles.searchDynamicDropdown}
                label={translate("Brand")}
                onSelectionChange={onSelectionChangeHandler}
                onInputChange={onInputChanged}
                filterOption={() => true}
                selected={getWishListsParameter.brandId}
                options={options}
                placeholder={translate("Search for a brand")}
            />
        </SearchFieldWrapper>
    );
};

export default MyListsSearchFieldBrand;
